import { ITariffLine } from '~/src/entities/tariff-lines';

export const getTarifflLinesWithSortedShopItems = (tariffLines: ITariffLine[]) => {
    return tariffLines.map(tariffLine => {
        const shopItems = tariffLine.shopItems.sort((shopItemA, shopItemB) => {
            const sortPropA = shopItemA.props?.find(prop => prop.name === 'weight')?.value;
            const sortPropB = shopItemB.props?.find(prop => prop.name === 'weight')?.value;

            if (typeof sortPropA === 'number' && typeof sortPropB === 'number') {
                return sortPropA - sortPropB;
            }

            return 0;
        });

        tariffLine.shopItems = shopItems;

        return { ...tariffLine };
    });
};
